import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  kicker,
  title,
  description,
  linkTo,
  linkLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
      <div>
        {kicker && (
          <p className="mb-1.5 text-[11px] font-semibold tracking-[0.2em] text-accent-600 uppercase">
            {kicker}
          </p>
        )}
        <h2 className="text-xl md:text-2xl font-extrabold tracking-tight text-foreground-950">
          {title}
        </h2>
        {description && <p className="mt-1.5 text-sm text-foreground-600">{description}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}